angular.module('admin.menus.tree', [
  'ui.tree',
  'security.authorization',
  'services.utility',
  'resources.Category',
  'services.adminResource'
]);

angular.module('admin.menus.tree').config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.menus.tree', {
      url: '/tree',
      title: 'Manage Menus',
      views: {
        'main@': {
          template: require('./menus-tree.tpl.html'),
          controller: 'MenusTreeCtrl',
          resolve: {
            menus: ["adminResource", function(adminResource) {
              return adminResource.getMenusTree({path: '/', depth: 2});
            }]
          }
        }
      }
    });
}]);

angular.module('admin.menus.tree').controller('MenusTreeCtrl', ['$scope', '$route', '$location', '$log', '$modal', 'utility', 'adminResource', 'menus', 'Category',
  function($scope, $route, $location, $log, $modal, utility, adminResource, data, Category){
    // local var
    var deserializeData = function(data){
      $scope.menus = data;
    };

    var fetchMenus = function(){

      adminResource.findMenus($scope.filters).then(function(data){
        deserializeData(data);

        //update url in browser addr bar
        $location.search($scope.filters);
      }, function(e){
        $log.error(e);
      });
    };

    // $scope methods
    $scope.canSave = utility.canSave;
    $scope.filtersUpdated = function(){
      //reset pagination after filter(s) is updated
      $scope.filters.page = undefined;
      fetchMenus();
    };
    $scope.prev = function(){
      $scope.filters.page = $scope.pages.prev;
      fetchMenus();
    };
    $scope.next = function(){
      $scope.filters.page = $scope.pages.next;
      fetchMenus();
    };

    $scope.toggleNode = function(node) {
      var modelValue = node.$nodeScope.$modelValue;
      var pathLength = modelValue.path.split('/').filter(Boolean).length;
      var objPath = 'children' + (new Array(pathLength).join('.[0].children'));
      var children = {};

      adminResource.getMenusTree({path: modelValue.path, depth: 2}).then(function(result) {
        if (!result.length) {
          return;
        }

        result = result[0];
        modelValue.children = _.get(result, objPath);
        node.toggle();
      });
    };

    var generateCategoryOptions = function(items, container) {

      items.forEach(function(item) {

        if (!item.path) {
          return;
        }

        //console.log(item);
        var depth = item.path.split('/').filter(Boolean).length;
        var indent = (new Array(7)).join(String.fromCharCode(160));

        container.push({
          _id: item._id,
          id: item.name,
          path: item.path,
          name: (new Array(depth)).join(indent) + item.name
        });

        if (item.children) {
          generateCategoryOptions(item.children, container);
        }
      });

      return container;
    };

    function getOrderedMenu( menu, parent ) {
      var flat = [];
      menu.forEach( function(m) {
        flat.push({
          _id: m._id,
          sefriendly: m.sefriendly,
          parent: parent ? parent : '/',
          order: 0,
        });
        if( m.children.length ) {
          flat = flat.concat(getOrderedMenu( m.children, parent + '/' + m.sefriendly ));
        }
      });

      return flat;
    }

    var ActionStates = require('../../utils/action-states');
    $scope.menuState = new ActionStates.StateClass();
    $scope.treeOptions = {
      dropped: function (e) {
        $scope.menuState.notSaved();
      }
    };

    $scope.saveMenuOrder = function() {
      $scope.menuState.waiting();
      var orderedMenu = getOrderedMenu($scope.menus, '');
      orderedMenu = orderedMenu.map( function(m, index) {
        m.order = index + 1;
        return m;
      });

      adminResource.updateMenus( orderedMenu).then(function(result) {
        if( result.ok )
          $scope.menuState.saveOk();
        else
          $scope.menuState.error();

      }, function(error) {
        $scope.menuState.error();
      });

    };

    $scope.addMenu = function() {
      //show modal
      var dialog = $modal.open({
        templateUrl: 'add_menu.tpl.html',
        controller: 'AddMenuCtrl',
        resolve: {
          options: function() {
            var options = [];
            return adminResource.getMenusTree().then(function(data) {
              generateCategoryOptions(data, options);
              return options;
            });
          },
          categories: function() {
            //$log.log("addMenu-->categories.----->");
            var optionscat = [];
            var genCatOptions = function(items, container) {
              items.forEach(function(item) {
                if (!item.path) {
                  return;
                }
                var depth = item.path.split('/').filter(Boolean).length;
                var indent = (new Array(7)).join(String.fromCharCode(160));
                container.push({
                  _id: item._id,
                  id: item.id,
                  path: item.path,
                  name: (new Array(depth)).join(indent) + item.name
                  });
                if (item.children) {
                  genCatOptions(item.children, container);
                }
              });
              return container;
            };
            return Category.getPermittedTree().$promise.then(function(data) {
              //$log.log("options.-----1>"+JSON.stringify(data));
              genCatOptions(data, optionscat);
              //$log.log("options.-----2>"+JSON.stringify(optionscat));
              return optionscat;
            });
          }
        }
      });
      dialog.result.then(function handleClose(result) {
        dialog.close();
        dialog = null;
        //if (node.$nodeScope.collapsed) {
        //  $scope.toggleNode(node);
        //}
      }, function handleDismiss() {
        dialog = null;
      });
    };

    $scope.editItem = function(node) {
      var modelValue = node.$nodeScope.$modelValue;

      //show modal
      var dialog = $modal.open({
        templateUrl: 'edit_menu.tpl.html',
        controller: 'EditMenuCtrl',
        resolve: {
          data: function() {
            return modelValue;
          },
          options: function() {
            var options = [];
            return adminResource.getMenusTree().then(function(data) {
              generateCategoryOptions(data, options);
              return options;
            });
          },
          categories: function() {
            //$log.log("editItem-->categories.----->");
            var optionscat = [];
            var genCatOptions = function(items, container) {
              items.forEach(function(item) {
                if (!item.path) {
                  return;
                }
                var depth = item.path.split('/').filter(Boolean).length;
                var indent = (new Array(7)).join(String.fromCharCode(160));
                container.push({
                  _id: item._id,
                  id: item.id,
                  path: item.path,
                  name: (new Array(depth)).join(indent) + item.name
                  });
                if (item.children) {
                  genCatOptions(item.children, container);
                }
              });
              return container;
            };
            return Category.getPermittedTree().$promise.then(function(data) {
              //$log.log("options.-----1>"+JSON.stringify(data));
              genCatOptions(data, optionscat);
              //$log.log("options.-----2>"+JSON.stringify(optionscat));
              return optionscat;
            });
          }
        }
      });
      dialog.result.then(function handleClose(result) {
        dialog.close();
        dialog = null;

        if (!result) {
          return node.remove();
        }

        node.$nodeScope.$modelValue.name =  result.name;
        node.$nodeScope.$modelValue.path =  result.path;
        node.$nodeScope.$modelValue.alias =  result.alias;
        node.$nodeScope.$modelValue.sefriendly =  result.sefriendly;
        node.$nodeScope.$modelValue.redirect =  result.redirect;
        node.$nodeScope.$modelValue.cat_id = result.cat_id;
      }, function handleDismiss() {
        dialog = null;
      });
    };

    // $scope vars
    //select elements and their associating options
    $scope.sorts = [
      {label: "id \u25B2", value: "_id"},
      {label: "id \u25BC", value: "-_id"},
      {label: "name \u25B2", value: "name"},
      {label: "name \u25BC", value: "-name"}
    ];
    $scope.limits = [
      {label: "10 Materiałów", value: 10},
      {label: "20 Materiałów", value: 20},
      {label: "50 Materiałów", value: 50},
      {label: "100 Materiałów", value: 100}
    ];


    //initialize $scope variables
    deserializeData(data.map(function(item) {
      var temp = angular.copy(item);
      //delete temp['children'];

      return temp;
    }));
  }
]);

var slug = function(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
  var to   = "aaaaaeeeeeiiiiooooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
};

angular.module('admin.menus.tree').controller('AddMenuCtrl', ['$scope', '$modalInstance', 'adminResource', 'options', 'Category', 'categories',
  function($scope, $modalInstance, adminResource, options, Category, categories) {

    $scope.options = options;
    $scope.categories =categories;
    $scope.hasEditedName = false;
    $scope.rootUrl = '';
    $scope.data = {
      name: '',
      sefriendly: '',
      alias: '',
      redirect: '',
      parent: '',
      cat_id: ''
    };

    $scope.changedName = function() {
      if (!$scope.hasEditedName) {
        $scope.data.sefriendly = slug($scope.data.name || '');
      }
    };

    $scope.editedName = function() {
      if ($scope.data.sefriendly !== '') {
        $scope.hasEditedName = true;
      }
    };

    $scope.editSefriendly = function() {
      $scope.showSefriendly = true;
    };

    $scope.saveSefriendly = function() {
      $scope.showSefriendly = false;
    };

    $scope.changedParent = function() {
      $scope.rootUrl = location.href.replace(location.pathname, '');
      if ($scope.data.parent) {
        $scope.rootUrl += $scope.data.parent.path;
      }

      $scope.rootUrl += '/';
    };

    $scope.save = function () {
      var parentPath = $scope.data.parent ? $scope.data.parent.path : '';
      var data = {
        name: $scope.data.name,
        path: parentPath + '/' + $scope.data.sefriendly,
        alias: $scope.data.alias,
        redirect: $scope.data.redirect,
        sefriendly: $scope.data.sefriendly,
        parent: parentPath || '/',
        cat_id: $scope.data.cat_id.id || -1
      };
      adminResource.addMenu(data).then(function(result) {
        $modalInstance.close(result.data);
      });
    };

    $scope.changedParent();

  }
]);

angular.module('admin.menus.tree').controller('EditMenuCtrl', ['$scope', '$modalInstance', 'adminResource', 'options','data', 'Category', 'categories',
  function($scope, $modalInstance, adminResource, options, data, Category, categories) {
    var parent = '';
    var cat_id = '';
    var parentPath = data.path.substring(0, data.path.lastIndexOf("/"));
    var sefriendly = data.path.substring(data.path.lastIndexOf("/")).replace('/','');
    options.forEach(function(item) {
      if (item.path === parentPath) {
        parent = item;
      }
    });
    categories.forEach(function(item) {
      if (item.id === data.cat_id) {
        cat_id = item;
      }
    });

    $scope.options = options;
    $scope.categories = categories;
    $scope.hasEditedName = true;
    $scope.rootUrl = '';
    $scope.data = {
      _id: data._id,
      path: data.path,
      name: data.name,
      sefriendly: sefriendly,
      alias: data.alias,
      redirect: data.redirect,
      parent: parent,
      order: data.order,
      cat_id: cat_id
    };

    $scope.changedName = function() {
      if (!$scope.hasEditedName) {
        $scope.data.sefriendly = slug($scope.data.name || '');
      }
    };

    $scope.editedName = function() {
      if ($scope.data.sefriendly !== '') {
        $scope.hasEditedName = true;
      }
    };

    $scope.editSefriendly = function() {
      $scope.showSefriendly = true;
    };

    $scope.saveSefriendly = function() {
      $scope.showSefriendly = false;
    };

    $scope.changedParent = function() {
      $scope.rootUrl = location.href.replace(location.pathname, '');
      if ($scope.data.parent) {
        $scope.rootUrl += $scope.data.parent.path;
      }

      $scope.rootUrl += '/';
    };

    $scope.save = function () {
      var catid = -1;
      if($scope.data.cat_id){
        catid = $scope.data.cat_id.id;
      }

      var parentPath = $scope.data.parent ? $scope.data.parent.path : '';
      var data = {
        _id: $scope.data._id,
        name: $scope.data.name,
        path: parentPath + '/' + $scope.data.sefriendly,
        alias: $scope.data.alias,
        redirect: $scope.data.redirect,
        sefriendly: $scope.data.sefriendly,
        parent: parentPath || '/',
        order: $scope.data.order,
        cat_id: catid
      };
      adminResource.updateMenu($scope.data._id, data).then(function(result) {
        $modalInstance.close(data);
      });
    };

    $scope.delete = function() {
      if (!confirm('Deleting parent will delete all children. Are you sure you want to continue?')) {
        return;
      }

      adminResource.deleteMenu(data._id).then(function(result) {
        $modalInstance.close(null);
      });
    };

    $scope.changedParent();

  }
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/menus/menus-tree.js